import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import EngagementFilter from './engagement.filter';
import {FormatDatePipe} from './formatDate.pipe';
import OnlyManagedArtistsFilter from './onlyManagedArtists.filter';
import {CallbackPipe} from "./callback.pipe";
import {BytePipe} from "./byte.pipe";
import {RelativeDatePipe} from "./relativeDate.pipe";
import {Nl2brFilter} from "./nl2br.filter";
import {UrlEncodePipe} from "./urlEncode.pipe";
import {StringAvatarPipe} from "./stringAvatar.pipe";



@NgModule({
    declarations: [
        EngagementFilter,
        FormatDatePipe,
        OnlyManagedArtistsFilter,
        CallbackPipe,
        BytePipe,
        RelativeDatePipe,
        Nl2brFilter,
        UrlEncodePipe,
        StringAvatarPipe
    ],
    exports: [
        FormatDatePipe,
        EngagementFilter,
        OnlyManagedArtistsFilter,
        CallbackPipe,
        BytePipe,
        RelativeDatePipe,
        Nl2brFilter,
        UrlEncodePipe,
        StringAvatarPipe
    ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
